import { colors, IconButton } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { toggleForceToExpandNavigation } from '../NavigationContext';

import './Logo.css';

export const Logo = () => {
  const { t } = useTranslation('global');
  const companyId = useCompanyId();
  const history = useHistory();
  return (
    <div className="flex items-center justify-between">
      <IconButton
        iconName="spendesk"
        color={colors.contentPrimary}
        aria-hidden="true"
        className="shrink-0 cursor-pointer"
        aria-label={t('homepage.name')}
        onClick={() => {
          history.push(
            routeFor(routes.HOMEPAGE.path, {
              company: companyId,
            }),
          );
        }}
      />
      <IconButton
        className="navigation-toggle-display text-content-primary"
        iconName="left-menu"
        aria-label={t('navigation.expandedOrCollapseNavigation')}
        onClick={() => {
          toggleForceToExpandNavigation();
        }}
      />
    </div>
  );
};
